import { Collection } from 'immutable';

// The search only reads each queue's description, so we accept any ordered
// Immutable collection of description-bearing items. That lets this helper
// serve both the raw queues Map and the favorites-sorted List without coupling
// to a concrete queue shape.
type QueueLike = { get(key: 'description'): string | undefined };

// Above this many queues we make the list taller and show a search field.
export const QUEUE_COUNT_THRESHOLD = 6;

/** Whether the queue list is long enough to warrant a search field + taller list. */
export const shouldShowQueueSearch = (queues: { size: number }): boolean =>
    queues.size > QUEUE_COUNT_THRESHOLD;

/**
 * Filters queues by a case-insensitive substring match on their description,
 * preserving the collection's order. Queues without a description are matched
 * only by the empty search term.
 */
export const filterQueuesBySearch = <Q extends QueueLike>(
    queues: Collection<unknown, Q>,
    search: string,
): Q[] => {
    const term = search.trim().toLowerCase();
    return queues
        .valueSeq()
        .filter((queue) =>
            (queue.get('description') || '').toLowerCase().includes(term),
        )
        .toArray();
};
